/* eslint-disable import/first */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable quotes */
import React from "react";
import selectors from "./selectors";
import actions from "../../actions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class AdminDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      display_name: "",
      password: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(e) {
    fetch("api/v2/admin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: this.state.email,
        display_name: this.state.display_name,
        password: this.state.password,
      }),
    });
    e.preventDefault();
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-6">
            <div className="card">
              <form onSubmit={this.handleSubmit}>
                <div>
                  <label htmlFor="email">Email</label>
                  <input
                    name="email"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                </div>
                <div>
                  <label htmlFor="display_name">display_name</label>
                  <input
                    name="display_name"
                    placeholder="display_name"
                    value={this.state.display_name}
                    onChange={this.handleChange}
                  />
                </div>
                <div>
                  <label htmlFor="password">password</label>
                  <input
                    name="password"
                    placeholder="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                </div>
                <div>
                  <button className="button button-add">Add Admin</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

AdminDetail.defaultProps = {};

AdminDetail.propTypes = {
  getAdminSetting: PropTypes.func.isRequired,
  updateAdminSetting: PropTypes.func.isRequired,
};

export default connect(selectors, {
  ...actions.admin,
})(withRouter(AdminDetail));



// WEBPACK FOOTER //
// ./client/react/Admin/views/AdminDetail/index.js